import { Component } from '@angular/core';

@Component({
  selector: 'app-session-expired-dialog',
  templateUrl: './session-expired-dialog.component.html',
  styleUrls: ['./session-expired-dialog.component.sass']
})
export class SessionExpiredDialogComponent {

}
